(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/eurojackpot.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/eurojackpot.js'); 
'use strict';

var _svs$numbergames, _svs$numbergames$prod;
const EUROJACKPOT = {
  productId: (_svs$numbergames = svs.numbergames) === null || _svs$numbergames === void 0 ? void 0 : (_svs$numbergames$prod = _svs$numbergames.productMapping) === null || _svs$numbergames$prod === void 0 ? void 0 : _svs$numbergames$prod.CONSTANTS.EUROJACKPOT,
  rowPrice: 25,
  numbersMaxValue: 50,
  numbersMaxLength: 5,
  numbersExtraMaxValue: 12,
  numbersExtraMaxLength: 2,
  maxNumberOfRows: 12,
  huxfluxManual: true,
  winConditions: [{
    numbers: 3
  }, {
    numbers: 2,
    numbersExtra: 1
  }, {
    numbers: 1,
    numbersExtra: 2
  }],
  possibleDrawCounts: [{
    value: '1',
    label: '1 V'
  }, {
    value: '5',
    label: '5 V'
  }, {
    value: '10',
    label: '10 V'
  }],
  PACKAGES: {
    100: {
      rows: 4
    },
    200: {
      rows: 8
    },
    400: {
      rows: 16
    }
  },
  SYSTEM: {
    LIMITS: {
      NUMBERS: {
        minRowLength: 5,
        maxRowLength: 13,
        combinationMinLength: {
          2: 6,
          3: 5,
          4: 5,
          5: 5,
          6: 5,
          7: 5,
          8: 5,
          9: 5,
          10: 5,
          11: 5,
          12: 5
        },
        combinationMaxLength: {
          2: 13,
          3: 11,
          4: 9,
          5: 9,
          6: 8,
          7: 8,
          8: 7,
          9: 7,
          10: 7,
          11: 7,
          12: 6
        }
      },
      NUMBERS_EXTRA: {
        minRowLength: 2,
        maxRowLength: 12,
        combinationMinLength: {
          5: 3,
          6: 2,
          7: 2,
          8: 2,
          9: 2,
          10: 2,
          11: 2,
          12: 2,
          13: 2
        },
        combinationMaxLength: {
          5: 12,
          6: 12,
          7: 11,
          8: 7,
          9: 5,
          10: 3,
          11: 3,
          12: 2,
          13: 2
        }
      }
    }
  }
};
if (svs.isServer) {
  module.exports = {
    EUROJACKPOT
  };
} else {
  svs.numbergames.rules.EUROJACKPOT = EUROJACKPOT;
}
 })(window);